import { User } from "../@core/data/users";

export class Finance {
  id?: string;
  type?: string; //receipt/purchase/employee

  issueDate?: Date;
  issueDateSeconds?: number;
  issueDateMinutes?: number;
  issueDateHours?: number;
  issueDateDay?: number; //day of the month
  issueDateWeekDay?: number; //the day of the week, Sunday=0 - Saturday=6
  issueDateMonth?: number;
  issueDateYear?: number;

  code?: string;
  note?: string;
  tags?: string[];
  isReceive?: boolean;
  receiveAmount?: number;
  issueAmount?: number;
  noPrint?: number;
  isPrint?: boolean = false;
  isBankTransfer?: boolean;

  //person
  personId?: string;
  personName?: string;
  personMobile?: string;
  personAddress?: string;

  //Object
  customerId?: string;
  customerName?: string;
  supplierId?: string;
  supplierName?: string;
  employeeId?: string;
  employeeName?: string;
  objectType?: string; //customer/supplier/employee
  objectName?: string;

  //Advance
  groupId?: string;
  groupName?: string;
  receiptId?: string;

  //render
  balance?: number;
  editing?: boolean;
  loading?: boolean;

  //default
  shopId?: string;
  timestamp?: number;
  author?: User;
  createdBy?: string;
  createdOn?: Date;
  updatedBy?: string;
  updatedOn?: Date;
  isDeleted?: boolean;
  isActive?: boolean;
  visibility?: string;
  companyId?: string;
}
